import React from 'react'
import RaisedButton from 'material-ui-legacy/RaisedButton'
import ActionInfoOutline from 'material-ui-legacy/svg-icons/action/info-outline'

const IconButton = ({
  style,
  onTouchTap,
  onClick,
  label,
  icon,
  ...restProps
}) => (
  <RaisedButton
    style={style || { margin: '5px' }}
    onTouchTap={onTouchTap || onClick}
    label={label || ''}
    labelPosition="after"
    primary={true}
    icon={icon || <ActionInfoOutline />}
    {...restProps}
  />
)

export default IconButton



// WEBPACK FOOTER //
// ./src/components/UI/IconButton.jsx